export const filtersHasEmptyIdParam = (whereFilters = []) => !!whereFilters.find(({ field, value }) => {
    if (field === "id") {
        if (typeof value === "undefined") {
            return true;
        }
        if ((typeof value === "string" || Array.isArray(value)) && value.length === 0) {
            return true;
        }
    }
    return false;
});
//# sourceMappingURL=index.js.map